import { UserAttributesClient } from 'frontend-preferences-client';
import { THREAD_VIEW_FEATURE_SHEPHERDS_ALREADY_SEEN } from '../constants/userAttributeKeys';
const userAttributesClient = UserAttributesClient.forCaller('conversations-thread-view');
export const getSeenNewFeatureShepherds = () => userAttributesClient.fetch(THREAD_VIEW_FEATURE_SHEPHERDS_ALREADY_SEEN, '[]');
export const setSeenNewFeatureShepherds = ({
  value
}) => userAttributesClient.write(THREAD_VIEW_FEATURE_SHEPHERDS_ALREADY_SEEN, JSON.stringify(value));